import LocationSelector from './LocationSelector.vue';
export default LocationSelector;
